export {default as TabsPanel} from './tabs-panel';
export {SwitcherItem, SwitcherArgs} from '../../ko-components/switchers';
